import { useMutation } from '@tanstack/react-query';
import OCGatewayClient from '../client/OCGatewayClient';

export interface PreShippingSurveyPayload {
  orderName: string;
  addressConfirmed: boolean;
  catFlap: string;
  catFlapDetails: string;
  catCount: string;
  catCountOther: string;
  preyAttempts: string;
  catWeightStatus: string;
  catWeightNotes: string;
  powerWifi: string;
  accessories: string;
  additionalNotes: string;
}

export function usePreShippingSurveyMutation() {
  return useMutation({
    mutationFn: async (payload: PreShippingSurveyPayload) => {
      const response = await OCGatewayClient.httpRequest('POST', '/survey/pre-shipping', payload);

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body?.message || 'Unable to submit questionnaire right now.');
      }

      return true;
    }
  });
}
